import { useCallback } from "react";
import { Country } from "@lookiero/sty-psp-locale";
import { Segment } from "@lookiero/sty-psp-segment";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { TrackingEventName } from "./tracking";
import { useTrackPromocode } from "./useTrackPromocode";

interface TrackPromocodeInvalidFunctionArgs {
  readonly promocode: string;
}

interface TrackPromocodeInvalidFunction {
  (args: TrackPromocodeInvalidFunctionArgs): void;
}

interface UseTrackPromocodeInvalidFunctionArgs {
  readonly country: Country;
  readonly segment: Segment;
  readonly userId: string;
  readonly tradename: Tradename;
}

interface UseTrackPromocodeInvalidFunction {
  (agrs: UseTrackPromocodeInvalidFunctionArgs): TrackPromocodeInvalidFunction;
}

const useTrackPromocodeInvalid: UseTrackPromocodeInvalidFunction = ({ country, segment, tradename, userId }) => {
  const trackPromocode = useTrackPromocode({
    event: TrackingEventName.PROMOCODE_INVALID,
    country,
    segment,
    tradename,
    userId,
  });

  const trackPromocodeInvalid: TrackPromocodeInvalidFunction = useCallback(
    ({ promocode }) => {
      trackPromocode({ promocode });
    },
    [trackPromocode],
  );

  return trackPromocodeInvalid;
};

export { useTrackPromocodeInvalid };
